import React from 'react';

export const KineticNovelIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    strokeWidth="0.529"
                    d="M0 3.704H4.762V4.2330000000000005H0z"
                ></path>
                <path
                    fill="#fff"
                    fillOpacity="1"
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M4.233 2.91L5.821 3.97 4.233 5.027z"
                ></path>
                <text
                    xmlSpace="preserve"
                    style={{ lineHeight: '1.25' }}
                    x="1.552"
                    y="3.145"
                    strokeWidth="0.265"
                    fontFamily="sans-serif"
                    fontSize="2.822"
                    letterSpacing="0"
                    wordSpacing="0"
                >
                    <tspan
                        x="1.552"
                        y="3.145"
                        style={{}}
                        fill="#fff"
                        fillOpacity="1"
                        strokeWidth="0.265"
                        fontFamily="sans-serif"
                        fontSize="2.822"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                    >
                        K
                    </tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    style={{ lineHeight: '1.25' }}
                    x="-6.251"
                    y="-0.893"
                    strokeWidth="0.265"
                    fontFamily="sans-serif"
                    fontSize="1.411"
                    letterSpacing="0"
                    wordSpacing="0"
                ></text>
            </g>
        </svg>
    );
};
